import { Injectable, inject, computed } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { environment } from '@env/environment';

/**
 * TenantContextService — resuelve el tenant_slug desde:
 *  1. Subdominio del host (ej. cliente1.fuga-control.com → 'cliente1').
 *  2. Si no hay subdominio (localhost dev), usa override por queryParam.
 */
@Injectable({ providedIn: 'root' })
export class TenantContextService {
  private readonly auth = inject(AuthService);

  readonly tenantSlug = computed(() => this.resolveSlug());
  readonly tenantId = computed(() => this.auth.tenantId());

  private resolveSlug(): string | null {
    const host = window.location.hostname;
    const suffix = environment.domainSuffix;
    if (host.endsWith(`.${suffix}`)) {
      return host.slice(0, -1 - suffix.length) || null;
    }
    return null;
  }
}
